import { useState } from 'react';
import { Link, PageHeader } from 'shared-components';
import { Text, Checkbox } from '@chakra-ui/react';

interface IProps {
  id: string;
  label?: string;
  blurb?: string;
  isTicked: boolean;
  checkboxLabel?: string;
  externalLink?: { link: string; text: string };
  onChange: (key: string, value: boolean) => void;
}

const CheckBoxQuestion = (props: IProps) => {
  const [isTicked, setIsTicked] = useState(props.isTicked);

  const onChange = () => {
    const newVal = !isTicked;
    setIsTicked(newVal);
    props.onChange(props.id, newVal);
  };

  return (
    <>
      <PageHeader>{props.label}</PageHeader>

      <Text fontSize="lg" dangerouslySetInnerHTML={{ __html: props.blurb! }} />

      {props.externalLink ? (
        <Link href={props.externalLink.link} isExternal>
          {props.externalLink.text}
        </Link>
      ) : null}

      <Checkbox
        data-selector={`checkbox-label`}
        id={props.id}
        isChecked={isTicked}
        onChange={onChange}
        variant="outline"
        size="lg"
      >
        {props.checkboxLabel}
      </Checkbox>
    </>
  );
};

export default CheckBoxQuestion;
